/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, VbzModal } from '@smiles/voebiz-ui-kit';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useWindowSize } from 'usehooks-ts';
import { ArrowLeftIcon } from '../../Icons/ArrowLeftIcon';

export interface IModal {
  component: string;
  imageClass: string;
  isOpen: boolean;
  onClick: (...args: any[]) => any;
  secondClick?: (...args: any[]) => any;
}

const ModalDefault = ({ component, isOpen, imageClass, onClick, secondClick }: IModal) => {
  const { t } = useTranslation(component);
  const { width } = useWindowSize();
  const isMobile = useMemo(() => width < 768, [width]);

  return (
    <>
      <VbzModal className="vbz-modal-default" isOpen={isOpen} hideHeader>
        <div className="vbz-modal-default-btn-container">
          {isMobile ? (
            <button className="modal-circle" type="button" onClick={onClick} data-testid="button-modal-onclick">
              X
            </button>
          ) : (
            <button className="modal-circle-arrow" type="button" onClick={onClick} data-testid="button-modal-onclick">
              <ArrowLeftIcon />
            </button>
          )}
        </div>
        <div className="ml-5 vbz-modal-default-image-container">
          <div className="mb-4">
            <div className={imageClass} />
          </div>
        </div>
        <div className="ml-5 mb-4 vbz-modal-default-title-container">
          <h4>{t('title')}</h4>
        </div>
        <div className="ml-5 mb-5 d-flex vbz-modal-default-description-container">
          <div>{t('description')}</div>
        </div>
        <div className="ml-5 d-none d-md-inline" data-testid="modal-container-desktop">
          <Button
            onClick={() => {
              secondClick ? secondClick() : onClick();
            }}
          >
            <span data-testid="button-text-desk-testid">{t('button_text')}</span>
          </Button>
        </div>
        <div className="w-100 d-flex d-md-none vbz-modal-default-button-container" data-testid="modal-container-mobile">
          <Button
            onClick={() => {
              secondClick ? secondClick() : onClick();
            }}
            className="w-100"
          >
            <span data-testid="button-text-mobile-testid">{t('button_text')}</span>
          </Button>
        </div>
      </VbzModal>
    </>
  );
};

export default ModalDefault;
